import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import NoRecruiterPositionsContainer from 'src/components/recruiterPositions/NoRecruiterPositionsContainer';
import Container from 'src/components/shared/Container';
import { useRecommendationsContext } from 'src/context/RecommendationsProvider';
import { useUserContext } from 'src/context/UserProvider';
import { useGetPositionsForRecruiterQuery } from 'src/hooks/position.hooks';
import { sendTrackingEvent } from 'src/utils/gtm';
import { PositionStatus, UserExperienceLevelType } from 'types';
import { Loader } from 'ui';
import NewRecruiterPositionsContainer from './NewRecruiterPositionsContainer';
import { Drawer } from 'src/components/shared/Drawer';
import PositionCreationModalFormForRecruiter from 'src/components/newRecruiterFlow/freshers/PositionCreationModalFormForRecruiter';
import { useMediaQuery } from '@mui/material';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';

const NewRecruiterPositionsPage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const isMobile = useMediaQuery('(max-width:960px)');
	const { isAccountManagerLoggedIn } = useUserContext();
	const [openCreatePositionModal, setOpenCreatePositionModal] = useState(false);
	const { setPositions, setIsLoadingPositions, filterApplied } = useRecommendationsContext();

	const {
		data: positionsData,
		isLoading: isPositionsDataLoading,
		isError: isPositionsDataError,
	} = useGetPositionsForRecruiterQuery(isAccountManagerLoggedIn, '', data => setPositions(data.positions ?? []));


	const hasPositions = !filterApplied && !!positionsData?.positions?.length;

	const disableCreate = !!positionsData?.positions?.find(
		p =>
			!p?.position?.isPublished &&
			p.position.positionStatus === PositionStatus.OPEN &&
			dayjs().isBefore(p.position.expiresAt),
	);

	const handleCreatePosition = () => {
		sendTrackingEvent({
			event: 'recr_dashboard_postajob',
			eventLabel: location.pathname,
		});
		setOpenCreatePositionModal(true);
	};

	useEffect(() => {
		setIsLoadingPositions(isPositionsDataLoading);
	}, [isPositionsDataLoading]);

	if (isPositionsDataLoading) {
		return (
			// <Loader />
			<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
		);
	}

	if (isPositionsDataError || !positionsData?.positions) {
		// return error screen
		return null;
	}

	return (
		<>
			<Container>
				{hasPositions ? (
					<>
						<NewRecruiterPositionsContainer
							positionsData={positionsData.positions}
							AllpositionsCount={positionsData.AllpositionsCount}
							allActivePositionsCount={positionsData.allActivePositionsCount}
							allClosedPositionsCount={positionsData.allClosedPositionsCount}
							myPositionsCount={positionsData.myPositionsCount}
							myActivePositionsCount={positionsData.myActivePositionsCount}
							myClosedPositionsCount={positionsData.myClosedPositionsCount}
							handleCreatePosition={handleCreatePosition}
							disableCreate={disableCreate}
							totalPositions={positionsData.totalPositions ?? 0}
						/>
					</>
				) : (
					<>
						<div className="h-[calc(100vh-70px)] sm:h-[calc(100vh-140px)] min-h-[350px] flex flex-col items-center justify-center">
							<NoRecruiterPositionsContainer onClick={handleCreatePosition} />
						</div>
					</>
				)}

				<Drawer
					fullWidth={true}
					backgroundColor="#F7F9FB"
					backDropColor="rgba(0, 0, 0, 0.70)"
					header={
						<div className="px-0 md:px-[14px] pt-6">
							<div className="text-[#004FC4] mx-[16px] font-[400] text-sm md:text-base py-2 md:py-[15px] px-[12px] md:px-[19px] rounded-[8px] bg-[#E5F0FF]">
								Kindly confirm the job details before you proceed with shortlisting candidates.
							</div>
						</div>
					}
					isModal={!isMobile}
					modalMaxWidth="760px"
					isOpen={openCreatePositionModal}
					body={
						<div>
							<PositionCreationModalFormForRecruiter
								isModal={true}
								experienceLevelBuckets={[UserExperienceLevelType.FRESHER]}
							/>
						</div>
					}
					onClose={() => {
						setOpenCreatePositionModal(false);
					}}
				/>
			</Container>
		</>
	);
};

export default NewRecruiterPositionsPage;
